<template>
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 32 32"
      fill="currentColor"
      :width="width"
      :height="height"
    >
      <path d="M31.4697 11.1173L16.4697 3.11733C16.325 3.04029 16.1636 3 15.9997 3C15.8358 3 15.6744 3.04029 15.5297 3.11733L0.529688 11.1173C0.369693 11.2026 0.235888 11.3298 0.142587 11.4852C0.0492867 11.6407 0 11.8185 0 11.9998C0 12.1811 0.0492867 12.359 0.142587 12.5145C0.235888 12.6699 0.369693 12.7971 0.529688 12.8823L3.99969 14.7336V20.7861C3.99865 21.2773 4.17942 21.7515 4.50719 22.1173C6.14469 23.9411 9.81344 26.9998 15.9997 26.9998C18.0509 27.0168 20.0867 26.6453 21.9997 25.9048V29.9998C21.9997 30.2651 22.105 30.5194 22.2926 30.7069C22.4801 30.8945 22.7345 30.9998 22.9997 30.9998C23.2649 30.9998 23.5193 30.8945 23.7068 30.7069C23.8943 30.5194 23.9997 30.2651 23.9997 29.9998V24.9386C25.3037 24.1858 26.4821 23.2339 27.4922 22.1173C27.82 21.7515 28.0007 21.2773 27.9997 20.7861V14.7336L31.4697 12.8823C31.6297 12.7971 31.7635 12.6699 31.8568 12.5145C31.9501 12.359 31.9994 12.1811 31.9994 11.9998C31.9994 11.8185 31.9501 11.6407 31.8568 11.4852C31.7635 11.3298 31.6297 11.2026 31.4697 11.1173ZM15.9997 24.9998C10.5909 24.9998 7.40969 22.3573 5.99969 20.7861V15.7998L15.5297 20.8823C15.6744 20.9594 15.8358 20.9997 15.9997 20.9997C16.1636 20.9997 16.325 20.9594 16.4697 20.8823L21.9997 17.9336V23.7261C20.4247 24.4611 18.4397 24.9998 15.9997 24.9998ZM25.9997 20.7811C25.4002 21.4463 24.7296 22.0436 23.9997 22.5623V16.8661L25.9997 15.7998V20.7811ZM23.4997 14.8673L23.4722 14.8511L16.4722 11.1173C16.2386 10.998 15.9676 10.9753 15.7174 11.0539C15.4672 11.1326 15.258 11.3064 15.1347 11.5378C15.0114 11.7693 14.984 12.0399 15.0583 12.2914C15.1327 12.5429 15.3029 12.7551 15.5322 12.8823L21.3747 15.9998L15.9997 18.8661L3.12469 11.9998L15.9997 5.13358L28.8747 11.9998L23.4997 14.8673Z" fill="currentColor"/>
    </svg>
  </template>
  
  <script>
  export default {
    props: {
      width: {
        type: [Number, String],
        default: 32,
      },
      height: {
        type: [Number, String],
        default: 32,
      },
    },
  }
  </script>